import {
  LOADING_RETRO_BOARDS,
  LOAD_RETRO_BOARDS,
  ERROR_RETRO_BOARDS,
  LOADING_RETRO_BOARD_DETAIL,
  LOAD_RETRO_BOARD_DETAIL,
  ERROR_RETRO_BOARD_DETAIL,
  RESET_RETRO_CURRENT_BOARD,
  SET_RETRO_TABLERO,
  SET_RETRO_VOTANTES,
  ADD_RETRO_CARD,
  REMOVE_RETRO_CARD,
  RESTORE_RETRO_CARD,
  PATCH_RETRO_CARD,
  SET_RETRO_COLUMN_CARDS,
} from "./retroBoardTypes";

// Estado del Tablero de Retrospectiva (spec 006, plan.md §3.2): { boards, currentBoard, loading, error }.
// currentBoard agrupa lo que ve RetroBoard.jsx al abrir un tablero concreto: metadata (tablero), catálogo
// de columnas (columnas), tarjetas con sus agregados (tarjetas) y quién votó/likeó (votantes, RF-18).
const emptyCurrentBoard = { tablero: null, columnas: [], tarjetas: [], votantes: [] };

const initial = {
  boards: [],
  currentBoard: { ...emptyCurrentBoard },
  loading: false,
  error: false,
};

const restoreCardAt = (tarjetas, card, index) => {
  const next = [...tarjetas];
  const at = index >= 0 && index <= next.length ? index : next.length;
  next.splice(at, 0, card);
  return next;
};

const retroBoardReducer = (state = initial, action) => {
  switch (action.type) {
    case LOADING_RETRO_BOARDS:
      return { ...state, boards: [], loading: true, error: false };
    case LOAD_RETRO_BOARDS:
      return { ...state, boards: action.payload || [], loading: false, error: false };
    case ERROR_RETRO_BOARDS:
      return { ...state, boards: [], loading: false, error: true };

    case LOADING_RETRO_BOARD_DETAIL:
      return { ...state, currentBoard: { ...emptyCurrentBoard }, loading: true, error: false };
    case LOAD_RETRO_BOARD_DETAIL:
      return {
        ...state,
        currentBoard: {
          tablero: action.payload.tablero,
          columnas: action.payload.columnas || [],
          tarjetas: action.payload.tarjetas || [],
          votantes: action.payload.votantes || [],
        },
        loading: false,
        error: false,
      };
    case ERROR_RETRO_BOARD_DETAIL:
      return { ...state, loading: false, error: true };
    case RESET_RETRO_CURRENT_BOARD:
      return { ...state, currentBoard: { ...emptyCurrentBoard } };

    case SET_RETRO_TABLERO:
      return {
        ...state,
        currentBoard: { ...state.currentBoard, tablero: action.payload },
      };
    case SET_RETRO_VOTANTES:
      return {
        ...state,
        currentBoard: { ...state.currentBoard, votantes: action.payload || [] },
      };

    case ADD_RETRO_CARD:
      return {
        ...state,
        currentBoard: {
          ...state.currentBoard,
          tarjetas: [...state.currentBoard.tarjetas, action.payload],
        },
      };
    case REMOVE_RETRO_CARD:
      return {
        ...state,
        currentBoard: {
          ...state.currentBoard,
          tarjetas: state.currentBoard.tarjetas.filter(
            (t) => t.IdTarjeta !== action.payload.idTarjeta
          ),
        },
      };
    // Rollback de un borrado fallido: reinserta la tarjeta en su posición original.
    case RESTORE_RETRO_CARD:
      return {
        ...state,
        currentBoard: {
          ...state.currentBoard,
          tarjetas: restoreCardAt(
            state.currentBoard.tarjetas,
            action.payload.card,
            action.payload.index
          ),
        },
      };
    // Parche genérico (texto editado, o agregados de voto/like tras optimismo/confirmación/rollback).
    case PATCH_RETRO_CARD:
      return {
        ...state,
        currentBoard: {
          ...state.currentBoard,
          tarjetas: state.currentBoard.tarjetas.map((t) =>
            t.IdTarjeta === action.payload.idTarjeta
              ? { ...t, ...action.payload.patch }
              : t
          ),
        },
      };
    // Reemplaza el orden de las tarjetas de UNA columna (reorder RF-10); las demás columnas no se tocan.
    case SET_RETRO_COLUMN_CARDS:
      return {
        ...state,
        currentBoard: {
          ...state.currentBoard,
          tarjetas: [
            ...state.currentBoard.tarjetas.filter(
              (t) => t.IdColumna !== action.payload.idColumna
            ),
            ...action.payload.tarjetas,
          ],
        },
      };

    default:
      return state;
  }
};

export default retroBoardReducer;
